
(function () {
  const root = document.documentElement;
  const buttons = document.querySelectorAll('[data-set-language]');
  function setLang(lang) {
    if (lang !== 'en' && lang !== 'bs') return;
    root.lang = lang;
    buttons.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.setLanguage === lang)));
    try { localStorage.setItem('ptt-lang', lang); } catch (e) {}
  }
  buttons.forEach((b) => b.addEventListener('click', () => setLang(b.dataset.setLanguage)));
  let saved = null;
  try { saved = localStorage.getItem('ptt-lang'); } catch (e) {}
  setLang(saved === 'bs' ? 'bs' : 'en');

  document.querySelectorAll('[data-nav-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  });

  // Contact form: allow email and/or phone. Phone is also copied into the message
  // so it always shows up in the email you receive.
  document.querySelectorAll('form#ContactForm').forEach((form) => {
    const email = form.querySelector('[data-contact-email]');
    const phone = form.querySelector('[data-contact-phone]');
    const body = form.querySelector('[data-contact-body]');
    if (!email || !phone || !body) return;
    const sync = () => { email.required = phone.value.trim() === ''; };
    email.addEventListener('input', sync);
    phone.addEventListener('input', sync);
    sync();
    form.addEventListener('submit', () => {
      const ph = phone.value.trim();
      if (ph && !body.value.includes('Phone: ' + ph)) body.value = body.value + '\n\nPhone: ' + ph;
      if (!email.value.trim()) email.value = 'phone-only-message@' + (location.hostname || 'example.com');
    });
  });

  // Cart: quantity steppers. Changes are saved with Shopify's cart API and the page
  // then reloads, so the line prices, subtotal and total always match the quantity.
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    const note = form.querySelector('[data-cart-note]');
    let timer = null;
    let saving = false;

    const quantities = () =>
      Array.from(form.querySelectorAll('[data-qty-input]')).map((i) => Math.max(0, parseInt(i.value, 10) || 0));

    const saveCart = () => {
      if (saving) return;
      saving = true;
      form.style.opacity = '.6';
      const payload = { updates: quantities() };
      if (note) payload.note = note.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
        .then((result) => {
          if (!result.ok) alert(result.data.description || result.data.message || 'Sorry, the cart could not be updated.');
          window.location.reload();
        })
        .catch(() => { window.location.reload(); });
    };

    form.querySelectorAll('[data-qty]').forEach((box) => {
      const input = box.querySelector('[data-qty-input]');
      const step = (d) => {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + d);
        clearTimeout(timer);
        timer = setTimeout(saveCart, 450);
      };
      box.querySelector('[data-qty-minus]').addEventListener('click', () => step(-1));
      box.querySelector('[data-qty-plus]').addEventListener('click', () => step(1));
      input.addEventListener('change', () => { clearTimeout(timer); saveCart(); });
    });

    const saveNote = () => {
      if (!note) return Promise.resolve();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).catch(() => {});
    };
    document.querySelectorAll('[data-continue-payment]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (!note) return;
        e.preventDefault();
        saveNote().then(() => { window.location.href = link.href; });
      });
    });
  });

  // Currency/country reset after checkout.
  // Shopify remembers the country chosen at checkout, so backing out left the store in
  // that country's currency. Remember the country the visitor had when they left for
  // checkout, and restore it if they come back with a different one.
  (function () {
    const KEY = 'ptt-pre-checkout-country';
    const meta = document.querySelector('meta[name="ptt-country"]');
    const current = meta ? meta.content : '';
    let saved = null;
    try { saved = sessionStorage.getItem(KEY); } catch (e) {}

    if (saved) {
      try { sessionStorage.removeItem(KEY); } catch (e) {}  // removed first so this can never loop
      if (current && saved !== current) {
        const body = new URLSearchParams({ form_type: 'localization', _method: 'put', country_code: saved, return_to: location.pathname });
        fetch('/localization', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        }).then(() => window.location.reload()).catch(() => {});
        return;
      }
    }

    document.querySelectorAll('a[href="/checkout"], a[href^="/checkout?"]').forEach((link) => {
      link.addEventListener('click', () => {
        try { if (current) sessionStorage.setItem(KEY, current); } catch (e) {}
      });
    });
  })();

  // If the browser shows a cart/payment page from its back-forward cache, reload it
  // so the quantities and prices are never out of date.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted && document.querySelector('[data-cart-form], .payment-page')) window.location.reload();
  });
})();